export enum PreferredTheme {
  DARK = 'dark',
  LIGHT = 'light',
}
